// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

export class ArrayHelper {
  /**
   * This method allows to filter an array to an array with unique values
   * (basic test with indexOf => for complex objects, we must personalized the test)
   * @param value
   * @param index
   * @param array
   */
  public static onlyUnique<T>(value: T, index: number, array: T[]): boolean {
    return array.indexOf(value) === index;
  }

  /**
   *
   * @param array1 2d-array
   * @param array2 2d-array
   * @returns true the two arrays are the same, false otherwise
   */
  public static equal(array1: unknown[][], array2: unknown[][]): boolean {
    if (!array1 && !array2) {
      return true;
    }
    if ((array1 && !array2) || (!array1 && array2) || array1.length !== array2.length) {
      return false;
    }
    for (let i = 0; i < array1.length; i++) {
      if (array1[i].length !== array2[i].length) {
        return false;
      }
      for (let j = 0; j < array1[i].length; j++) {
        if (array1[i][j] !== array2[i][j]) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Creates an array with all falsey values removed. The values false, null, 0, "", undefined, and NaN are falsey.
   * @param array
   * @returns
   */
  public static compact<T>(array: T[]): T[] {
    return array.filter((x) => !!x);
  }
}
